import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UserForm from './UserForm';
import { createUserRequest, initUserRequest } from '../../store/modules/users/actions';
import { selectUser } from '../../store/modules/users/selectors';
import { useActionDispatcher } from '../../hooks';

type Props = {
  showOnlyAdminSettings?: boolean;
};

const UserCreate = ({ showOnlyAdminSettings = false }: Props) => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initUserRequest());
    return () => {
      // dispatch(resetCurrentCustomer());
    };
  }, [dispatch]);

  const createUser = useActionDispatcher(createUserRequest);

  return (
    <UserForm
      creatingMode
      record={user}
      onSubmit={createUser}
      preventCancelChanges
      backToListLink
      title={user.data?.ref.full_name_first_last || ''}
      showOnlyAdminSettings={showOnlyAdminSettings}
    />
  );
};

export default UserCreate;
